import { user as userTools } from '@sellpy/commons'
import config from 'config'
import { gql } from 'graphql-tag'
import { locale } from '../../common/region/locale'
import { getCurrentUser } from '../../common/user/currentApolloUser'
import { getApolloClient } from '../apollo/apolloClientSingleton'
import { getIsCustomerImpersonation } from '../customerImpersonation/customerImpersonationData'

const USER_HASH_QUERY = gql`
  query getIntercomUserHash {
    getIntercomUserHash(environment: WEB) {
      _id
      userHash
    }
  }
`

let bootedUserId = undefined

const getIntercomUserProps = async () => {
  const user = await getCurrentUser()
  const isCustomerImpersonation = await getIsCustomerImpersonation()

  if (!userTools.userIsFull(user) || isCustomerImpersonation)
    return { created_at: null, email: null, name: null, user_id: null, user_hash: null }

  const { data } = await getApolloClient().query({
    query: USER_HASH_QUERY,
    fetchPolicy: 'network-only'
  })
  const { userHash } = data?.getIntercomUserHash || {}

  return {
    created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
    email: user.email,
    name: user.address ? `${user.address.firstName} ${user.address.lastName}` : undefined,
    user_id: user.objectId,
    user_hash: userHash
  }
}

export const updateIntercomUser = async () => {
  if (window.paymentData) return // Intercom is not initialized in app payments

  const intercomUserProps = await getIntercomUserProps()

  const isNewUserId = Boolean(bootedUserId !== intercomUserProps.user_id)
  if (bootedUserId && isNewUserId) {
    try {
      window.Intercom('shutdown')
    } catch (e) {
      console.warn('Intercom shutdown failed', e)
    }
  }

  if (isNewUserId) {
    window.Intercom('boot', {
      ...intercomUserProps,
      app_id: config.intercomId,
      custom_launcher_selector: '#intercom_launcher',
      language_override: locale,
      website_region: process.env.REGION
    })
  } else {
    window.Intercom('update', intercomUserProps)
  }
  bootedUserId = intercomUserProps.user_id
}
